/**
 * Conversation Partner Types
 *
 * TypeScript types for conversation partner data matching the backend schema.
 * Conversation partners represent people the user has conversations with
 * (primary partner, therapist, friends, family, etc.).
 */

export type ConversationPartnerType =
  | "primary_partner"
  | "therapist"
  | "friend"
  | "family"
  | "other";

export interface VoiceProfileSummary {
  id: string;
  sample_count: number;
  quality_score: number;
  total_duration_ms: number;
}

export interface ConversationPartner {
  id: string;
  user_id: string;
  name: string;
  pronouns: string | null;
  partner_type: ConversationPartnerType;
  is_primary: boolean;
  voice_profile: VoiceProfileSummary | null;
  created_at: string;
  updated_at: string;
}

export interface ConversationPartnerCreate {
  name: string;
  pronouns?: string | null;
  partner_type?: ConversationPartnerType;
  is_primary?: boolean;
}

export interface ConversationPartnerUpdate {
  name?: string;
  pronouns?: string | null;
  partner_type?: ConversationPartnerType;
}

export interface ConversationPartnerListResponse {
  partners: ConversationPartner[];
  total: number;
}

export interface SetPrimaryPartnerResponse {
  success: boolean;
  message: string;
  partner: ConversationPartner;
}

export const PARTNER_TYPE_LABELS: Record<ConversationPartnerType, string> = {
  primary_partner: "Primary Partner",
  therapist: "Therapist",
  friend: "Friend",
  family: "Family",
  other: "Other",
};
